import api from './api';

const settingsService = {
  // Profile endpoints
  getUserProfile: async () => {
    const response = await api.get('/settings/profile');
    return response.data;
  },

  getUserPlan: async () => {
    const response = await api.get('/subscriptions/payments');
    return response.data;
  },

  updateUserProfile: async (profileData) => {
    const response = await api.put('/settings/profile', profileData);
    return response.data;
  },

  // Password endpoints
  changePassword: async (passwordData) => {
    const response = await api.post('/settings/password/change', passwordData);
    return response.data;
  },

  // Organization endpoints
  getOrganizationSettings: async () => {
    const response = await api.get('/settings/organization');
    return response.data;
  },

  updateOrganizationSettings: async (orgData) => {
    const response = await api.put('/settings/organization', orgData);
    return response.data;
  },

  // Organization logo endpoints
  uploadOrganizationLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/settings/organization/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  uploadAvatarLogo: async (file,id) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post(`/settings/upload-avatar/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteOrganizationLogo: async () => {
    const response = await api.delete('/settings/organization/logo');
    return response.data;
  },

  // Preferences endpoints
  getUserPreferences: async () => {
    const response = await api.get('/settings/preferences');
    return response.data;
  },

  updateUserPreferences: async (preferencesData) => {
    const response = await api.put('/settings/preferences', preferencesData);
    return response.data;
  },

  // Security endpoints
  getSecuritySettings: async () => {
    const response = await api.get('/settings/security');
    return response.data;
  },

  toggleTwoFactor: async (enabled) => {
    const response = await api.post('/settings/security/two-factor', { enabled });
    return response.data;
  },

  postStatusColor: async (status)=>{
    const responce = await api.post('/settings/status-colors', status);
    return responce.data;
  },

  getStatusColors: async ()=>{
    const responce = await api.get('/settings/status-colors');
    return responce.data;
  }

};

export default settingsService;

